/**
 * @generated SignedSource<<5170fc9f99380eeb783bc5b545d856b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type dispatchInclusions_Refetch$variables = {
  id: string;
};
export type dispatchInclusions_Refetch$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"dispatchInclusions_MessageDispatchFragment">;
  } | null;
};
export type dispatchInclusions_Refetch = {
  response: dispatchInclusions_Refetch$data;
  variables: dispatchInclusions_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isDispatchCondition"
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rootNodeIds",
    "storageKey": null
  },
  (v4/*: any*/),
  (v5/*: any*/)
],
v8 = [
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v6/*: any*/),
    "type": "AccountDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v6/*: any*/),
    "type": "AllUserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userIds",
        "storageKey": null
      },
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "type": "UserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v7/*: any*/),
    "type": "TreeStartedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v7/*: any*/),
    "type": "TreeFinishedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v7/*: any*/),
    "type": "TreeUnlockedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v6/*: any*/),
    "type": "OptInDispatchCondition",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dispatchInclusions_Refetch",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "dispatchInclusions_MessageDispatchFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dispatchInclusions_Refetch",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "includes",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "excludes",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "type": "MessageDispatch",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5b162b6aacc48f7d5a23b8a64f7a1607",
    "id": null,
    "metadata": {},
    "name": "dispatchInclusions_Refetch",
    "operationKind": "query",
    "text": "query dispatchInclusions_Refetch(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...dispatchInclusions_MessageDispatchFragment\n    id\n  }\n}\n\nfragment dispatchConditionDropdown_MessageDispatchFragment on MessageDispatch {\n  id\n  includes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  excludes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n}\n\nfragment dispatchConditionsPreview_MessageDispatchFragment on MessageDispatch {\n  id\n  includes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  excludes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n}\n\nfragment dispatchInclusions_MessageDispatchFragment on MessageDispatch {\n  includes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  excludes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  ...dispatchConditionDropdown_MessageDispatchFragment\n  ...dispatchConditionsPreview_MessageDispatchFragment\n  id\n}\n\nfragment removeDispatchConditionButton_DispatchConditionFragment on DispatchCondition {\n  __isDispatchCondition: __typename\n  id\n}\n"
  }
};
})();

(node as any).hash = "383a2c2116d0657ff02e7a45f5304d9e";

export default node;
